import { useRouter } from 'next/router'

import { BalanceAlias, PaymentActionType } from '@/api/models/finance'
import { useBalancesPay } from '@/api/models/finance/hooks/useBalancesPay'
import { resolveBasePath } from '@/utils/deepLinkRouter'
import { isUrlAllowed } from '@/utils/url'

import { PaymentFormData } from '../sc/InvoicesDrawer/Payment/model/schemas'

type Props = {
  merchId: string
  invoiceIds: string[]
  receiptMethod: string
  paymentActionType: PaymentActionType
  balances: {
    alias: BalanceAlias
    personalAccountId: string
    amount: number
  }[]
  returnBackUrl?: string
}

export const usePay = ({
  merchId,
  invoiceIds,
  receiptMethod,
  paymentActionType,
  balances,
  returnBackUrl
}: Props) => {
  const { mutateAsync: makePayment, isPending: isPaymentPending } =
    useBalancesPay()
  const router = useRouter()

  const queryId = router.query.requestId ?? router.query.passId
  const id = Array.isArray(queryId) ? queryId[0] : queryId

  const getReturnUrl = () => {
    const basePath = resolveBasePath(router.pathname)
    const baseUrl = `${location.origin}${basePath}`
    return id ? `${baseUrl}/${id}` : baseUrl
  }

  const getSuccessReturnUrl = () => {
    const baseReturnUrl = getReturnUrl()
    return returnBackUrl ? `${baseReturnUrl}${returnBackUrl}` : baseReturnUrl
  }

  const handleMakePayment = async ({
    amount,
    email,
    cardId
  }: PaymentFormData & { cardId?: string }) => {
    if (!merchId) {
      return
    }

    const { data } = await makePayment({
      invoiceIds,
      amount: Number(amount) || 0,
      merchId,
      email: receiptMethod === 'email' ? email : null,
      successReturnUrl: getSuccessReturnUrl(),
      errorReturnUrl: getReturnUrl(),
      paymentActionType,
      balances,
      cardId
    })

    if (data?.url && isUrlAllowed(data?.url)) {
      window.location.href = `${data.url}?${data.body}`
    }
  }

  return {
    isPaymentPending,
    makePayment: handleMakePayment
  }
}
